import styled from "styled-components";
import { COLORS } from "../../../assets/constants/styles";

export const Container = styled.div`
  width: 100%;
  padding: 0;
`;

export const MainContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
`;

export const ConversationColumn = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.75rem;
`;

export const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background-color: ${COLORS.lightestViolet};
  border-radius: 0.75rem;
`;

export const ErrorContainer = styled.div`
  color: ${COLORS.red};
  margin-bottom: 1rem;
`;
